"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultGlmVersion3 = exports.DefaultGLM3Config = void 0;
var _defaultBrandContext = require("../../defaultBrandContext");
var _defaultIcons = require("../../productTable/defaultIcons");
var _defaultOptionalInclusions = require("../../productTable/staff/defaultOptionalInclusions");
var _defaultStaffInstructions = require("../../productTable/staff/defaultStaffInstructions");
var _defaultAboutOwner = require("../../quoteTools/defaultAboutOwner");
var _defaultAboutPet = require("../../quoteTools/defaultAboutPet");
var _defaultAuthorisedPersonDisplaySettings = require("../../quoteTools/defaultAuthorisedPersonDisplaySettings");
var _defaultCoverDisplayOptions = require("../../quoteTools/defaultCoverDisplayOptions");
var _defaultCustomRouteDefinitions = require("../../quoteTools/defaultCustomRouteDefinitions");
var _defaultPayment = require("../../quoteTools/defaultPayment");
var _defaultQuoteToolContext = require("../../quoteTools/defaultQuoteToolContext");
var _defaultRegularVetDisplaySettings = require("../../quoteTools/defaultRegularVetDisplaySettings");
var _defaultStepDefinitions = require("../../quoteTools/defaultStepDefinitions");
var _defaultSuccess = require("../../quoteTools/defaultSuccess");
var _defaultSummary = require("../../quoteTools/defaultSummary");
var _defaultStaffContext = require("../../quoteTools/staff/defaultStaffContext");
var _defaultGlmContext = require("./defaultGlmContext");
var _glm3StepDefinitions = require("./quoteTools/glm3StepDefinitions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DefaultGlmVersion3 = exports.DefaultGlmVersion3 = {
  glm: {
    version: 3,
    basicOwnerDetails: _defaultGlmContext.defaultAboutOwner,
    fullOwnerDetails: _defaultGlmContext.defaultAboutOwner
  }
};
var DefaultGLM3Config = exports.DefaultGLM3Config = {
  theme: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext), {}, {
    brand: _objectSpread(_objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.brand), DefaultGlmVersion3), {}, {
      styleSheet: 'glm3'
      // To-do: add necessary config for GLM3
    })
  }),
  quoteTools: {
    themeOverrides: _defaultQuoteToolContext.DefaultQuoteToolContext,
    steps: {
      StepDefinitions: _glm3StepDefinitions.GLM3StepDefinitions,
      basicOwnerDetails: _defaultAboutOwner.DefaultAboutOwner,
      fullOwnerDetails: _defaultAboutOwner.DefaultAboutOwner,
      aboutPet: _defaultAboutPet.DefaultAboutPet,
      coverDisplayOptions: _defaultCoverDisplayOptions.DefaultCoverDisplayOptions,
      summary: _defaultSummary.DefaultSummary,
      success: _defaultSuccess.DefaultSuccess,
      payment: _defaultPayment.defaultPayment,
      bannerStyle: 'bullets',
      showCompletedStepBannerOnPage: 'step6'
    },
    widgets: {
      authorisedPersonDisplaySettings: _defaultAuthorisedPersonDisplaySettings.defaultAuthorisedPersonDisplaySettings,
      regularVetDisplaySettings: _defaultRegularVetDisplaySettings.defaultRegularVetDisplaySettings
    },
    customRouteDefinitions: _defaultCustomRouteDefinitions.DefaultCustomRouteDefinitions,
    staffModeContext: _defaultStaffContext.DefaultStaffModeContext,
    productTable: {
      optionalInclusions: _defaultOptionalInclusions.DefaultOptionalInclusions,
      staffInstructions: _defaultStaffInstructions.DefaultStaffInstructions,
      icons: _defaultIcons.defaultIcons
    },
    middlewareApiKeys: {
      "public": {
        sit: {
          applicationId: '1BFB7E47-3488-4793-8161-18D90D29C087',
          apiKey: '2VD61B46EF909D40749',
          expiry: 3600
        },
        uat: {
          applicationId: '1BFB7E47-3488-4793-8161-18D90D29C087',
          apiKey: '2VD61B46EF909D40749',
          expiry: 3600
        },
        preprod: {
          applicationId: '330DEA3E-0A77-40AE-88AD-8F91026DDC20',
          apiKey: '81904FB7F31A4837A9',
          expiry: 3600
        },
        prod: {
          applicationId: 'A244829A-EB70-4C8F-B1D0-2C7F9C72D41F',
          apiKey: '3FA2A9BB331E447E99',
          expiry: 3600
        }
      }
    },
    recaptchaSiteKey: '6LdtR-skAAAAAGv4CmI_yD5F97jbpn2F5dmWB-ul',
    recaptchaSecretKey: '6LdtR-skAAAAAA6K3A8jCJOOkpu2V_ZbOq7AsoIX',
    recaptchaSiteKeyProd: '6LcCS-skAAAAAEv4ET1FC2cetZbvlfrDtcJwyWIp',
    recaptchaSecretKeyProd: '6LcCS-skAAAAABHxbb9R3yIxfo2-OVKBWzSg1OFL'
  }
};